<template>
  <div class="olympicMusicShowInstruments">
    <div class="title">选择乐器</div>

    <ul>
      <li v-for="item in professionals" :key="item.professionalId" @click="selectProfessionalHandle(item)">
        <span>{{item.name}}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'olympicMusicShowInstruments',
  computed: {
    competitiontypes: {
      get() {
        return this.$store.state.olympicMusicShow.competitiontypes
      }
    },
    selectCompetitiontype: {
      get() {
        return this.$store.state.olympicMusicShow.selectCompetitiontype
      }
    },
    selectProfessional: {
      get() {
        return this.$store.state.olympicMusicShow.selectProfessional
      },
      set(value) {
        this.$store.commit('olympicMusicShow/setSelectProfessional', value)
      }
    },
    competitiontypesName() {
      if (this.selectCompetitiontype) {
        return this.selectCompetitiontype.name
      } else {
        return ''
      }
    },
    professionals() {
      if (this.selectCompetitiontype) {
        return this.selectCompetitiontype.professionals
      } else {
        return []
      }
    }
  },
  mounted() {
    document.title = this.competitiontypesName
  },
  methods: {
    selectProfessionalHandle(item) {
      this.selectProfessional = item

      if (item.groups.length === 0) {
        if (this.selectCompetitiontype && this.selectCompetitiontype.isSingle) {
          this.$router.push({ path: 'singleRegister', query: { typeId: this.$route.query.typeId, professionalId: item.professionalId } })
        } else {
          this.$router.push({ path: 'multiRegister', query: { typeId: this.$route.query.typeId, professionalId: item.professionalId } })
        }
      } else {
        this.$router.push({ path: 'group', query: { typeId: this.selectCompetitiontype.typeId, professionalId: item.professionalId } })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/flexable.scss';

.olympicMusicShowInstruments {
  width: 100%;
  min-height: 100vh;
  background-color: #F5F5F9;
  .title {
    width: 100%;
    height: px2rem(110);
    padding-left: px2rem(32);
    line-height: px2rem(110);
    text-align: left;
    font-size: px2rem(36);
    font-weight: bold;
    color: #01C2C3;
    box-sizing: border-box;
  }

  ul {
    padding-bottom: px2rem(20);
    li {
      display: flex;
      align-items: center;
      margin-bottom: px2rem(20);
      width: 100%;
      height: px2rem(156);
      padding-left: px2rem(41);
      font-size: px2rem(36);
      font-weight: bold;
      color: #585858;
      background-color: #fff;
      box-sizing: border-box;
      &:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>